export const environment = {
  production: false,
  version: '3.3.0-beta',
  apiUrl: '/api',
  socketUrl: '',  // Empty = connect via current host/proxy (nginx proxies /socket.io/ to WS backend)
  recaptchaSiteKey: '',
  defaultLanguage: 'lv',
  supportedLanguages: ['en', 'uk', 'lv', 'ru'],

  dispatcher: {
    timerCriticalThresholdSeconds: 300,
    timerWarningThresholdSeconds: 600,
  },

  password: {
    minLength: 8,
    maxLength: 32,
    requireUppercase: true,
    requireLowercase: true,
    requireNumbers: true,
    requireSpecialChars: false, // optional - see general-docs/TODO-2026-08-22/password-policy-audit-2026-08-21.md
    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,32}$/
  }
};
